import React, {Fragment, useState, useEffect} from 'react'
import { Title, HeaderList, Cardlist,Container ,Card} from './styles'
import EventCard from '../EventCard'
import globals from 'react-global-configuration';

export const ListOfEvents = (props) => { 
    
    const _URL_REST = globals.get('_URL_REST');
    

    const [data, setData] = useState(null);
    const [hasInCategoria, setHasInCategoria] = useState(false);
    
    

    useEffect(() => { 
        //axios wait
        async function fetchData() {
            /*const result = await axios(
            `${_URL_REST}/${props.url}`,
            );*/

            try {
                var dataForm = {  
                    "claveUsuario":sessionStorage.getItem(`${process.env.REACT_APP_EVENTO_ID}index-Name_Id`),
                    "idEventoPadre": process.env.REACT_APP_EVENTO_ID
                  };
                const url = `https://eventosonline.spinmedia.es/api/eventos/EventosUsuarioDW`
                const requestOptions = {
                  method: 'POST',
                  body: JSON.stringify(dataForm),
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization':`Bearer ${sessionStorage.getItem(`${process.env.REACT_APP_EVENTO_ID}index-Nombre_TOKENUSERRADIO`)}`
                  },  
                }
                let respuesta = await fetch(url, requestOptions)
                let resultado = await respuesta.json()
                console.log('DATA::',resultado.data)
                resultado.data.forEach((item) => {
                    item.eventosCategorias.forEach((cat) => {
                        if(cat.idCategoria == props.idcategoria){
                            setHasInCategoria(true);
                        }
                    })
                })
                setData(resultado.data);
                
              } catch (error) {
                console.log('Error: ', error)
                console.log('user incorrecto::',sessionStorage.getItem(`${process.env.REACT_APP_EVENTO_ID}index-Name_Id`))
              }


        
        }
        fetchData();
    }, [_URL_REST,props.url]);

    if (!data) {
        return <div></div>  
    }

   
    
    return (
        <Fragment>
            <Container>
               
                <Cardlist ><Card>
                {
                data
                
                .map(item => 
                    <EventCard key={+new Date() + Math.random()} idevent={item.idEvento} fecha={item.fechaEvento} title={item.nombre}  />)
                }
                </Card>   

                </Cardlist>
                <div></div>
            </Container>
        </Fragment>
    )
}
